import { render, staticRenderFns } from "./TextBubbleControl.vue?vue&type=template&id=7b46a203&"
import script from "./TextBubbleControl.vue?vue&type=script&lang=js&"
export * from "./TextBubbleControl.vue?vue&type=script&lang=js&"
import style0 from "./TextBubbleControl.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports